export default () => ({
  cart: document.querySelector('cart-notification') || document.querySelector('cart-drawer'),
  wishlistCardErrorMessage: '',
  
  async addToCart(variantId) {
    const formData = new FormData();
    formData.append("id", Number(variantId))
    formData.append("form_type", "product")
    formData.append("sections", this.cart.getSectionsToRender().map((section) => section.id))
    formData.append("sections_url", window.location.pathname)
    this.cart.setActiveElement(document.activeElement);

    const addConfig = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': "application/javascript"
      },
      body: formData
    };

    try {
      const res = await fetch(routes.cart_add_url, addConfig);

      if (!res.ok) {
        if (res.status === 422) {
          this.wishlistCardErrorMessage = 'Not available, select another variant';
        } else {
          this.wishlistCardErrorMessage = 'Something went wrong';
        }
        return;
      }

      const response = await res.json();

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: formData.get('id'),
        cartData: response,
      });

      this.cart.renderContents(response);

      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }

      this.wishlistCardErrorMessage = '';
    } catch (err) {
      this.wishlistCardErrorMessage = 'Failed to add to cart';
    }
  },

  clearWishlist() {
    this.$store.main.removeAllItemsFromWishlist();
  }
})
